import { DATASETS_ROUTE } from "@/features/datasets/routes";
import { Link } from "react-router-dom";

/** The old curator is deprecated: a note at the top of its page. */
export const OldDatasetsBanner = ({ archived }: { archived: boolean }) => (
  <p
    role="note"
    className="rounded-[3px] border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900"
  >
    {archived ? (
      <>
        These are your old datasets. They stay viewable here, read-only. New datasets are built in{" "}
        <Link to={DATASETS_ROUTE} className="underline underline-offset-2 hover:text-amber-950">
          Datasets
        </Link>
        .
      </>
    ) : (
      "The old Datasets are being replaced by the new Datasets. Your existing datasets stay viewable."
    )}
  </p>
);
